import { render, staticRenderFns } from "./SettingsLabel.vue?vue&type=template&id=0cb16567&scoped=true"
import script from "./SettingsLabel.vue?vue&type=script&lang=js"
export * from "./SettingsLabel.vue?vue&type=script&lang=js"
import style0 from "./SettingsLabel.vue?vue&type=style&index=0&id=0cb16567&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb16567",
  null
  
)

export default component.exports